"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    //82 1 7 20 30 31 32 33 34 36 39 40 41 44 45 46 49 51 52 53 54 55 56 57 60 61 62 63 64 65 66 81 84 86 91 351 353 358 420 421 385 682 852 880 886
    { region: 'KR', code: '82' },
    { region: 'US', code: '1' },
    { region: 'RU', code: '7' },
    { region: 'EG', code: '20' },
    { region: 'GR', code: '30' },
    { region: 'NL', code: '31' },
    { region: 'BE', code: '32' },
    { region: 'FR', code: '33' },
    { region: 'ES', code: '34' },
    { region: 'HU', code: '36' },
    { region: 'IT', code: '39' },
    { region: 'RO', code: '40' },
    { region: 'CH', code: '41' },
    { region: 'GB', code: '44' },
    { region: 'DK', code: '45' },
    { region: 'SE', code: '46' },
    { region: 'DE', code: '49' },
    { region: 'PE', code: '51' },
    { region: 'MX', code: '52' },
    { region: 'CU', code: '53' },
    { region: 'AR', code: '54' },
    { region: 'BR', code: '55' },
    { region: 'CL', code: '56' },
    { region: 'CO', code: '57' },
    { region: 'MY', code: '60' },
    { region: 'AU', code: '61' },
    { region: 'ID', code: '62' },
    { region: 'PH', code: '63' },
    { region: 'NZ', code: '64' },
    { region: 'SG', code: '65' },
    { region: 'TH', code: '66' },
    { region: 'JP', code: '81' },
    { region: 'VN', code: '84' },
    { region: 'CN', code: '86' },
    { region: 'IN', code: '91' },
    { region: 'PT', code: '351' },
    { region: 'IE', code: '353' },
    { region: 'FI', code: '358' },
    { region: 'CZ', code: '420' },
    { region: 'SK', code: '421' },
    { region: 'HR', code: '385' },
    { region: 'CK', code: '682' },
    { region: 'HK', code: '852' },
    { region: 'BD', code: '880' },
    { region: 'TW', code: '886' },
];
